import { render, staticRenderFns } from "./TrainingDialogTabsSetup.vue?vue&type=template&id=1f336082&"
import script from "./TrainingDialogTabsSetup.vue?vue&type=script&lang=js&"
export * from "./TrainingDialogTabsSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports